/* 30.09.2026: винесено з layout/theme.liquid (раніше inline на кожній сторінці), підключено з defer */
      /* Глобальний репортер збоїв «додати в кошик».
         Дизайнер-попап репортить свої збої сам (stage 'cart'), але решта
         шляхів у кошик — конструктори, продуктові форми, апсели — падали
         мовчки. Тут перехоплюємо БУДЬ-ЯКИЙ AJAX POST на /cart/add*, що
         повернув не-2xx або мережеву помилку, і шлемо на приймач складу
         (stage 'cart-global'); склад пише журнал і тротлить Telegram.
         Нативні (не-AJAX) сабміти форм перехопити неможливо — але тема
         скрізь ходить через fetch/XHR. Ліміт 3 репорти на сторінку. */
      (function () {
        var REPORT_URL = 'https://bricktopia.vercel.app/api/health/storefront-error';
        var STORE = window.BT_CART_STORE || 'UA';
        var sent = 0;
        var pending = [];
        function fire(rec) {
          var i = pending.indexOf(rec);
          if (i > -1) pending.splice(i, 1);
          if (sent >= 3) return;
          sent++;
          try {
            fetch(REPORT_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              keepalive: true,
              body: JSON.stringify({
                stage: 'cart-global',
                store: STORE,
                message: ('HTTP ' + rec.status + (rec.detail ? ' — ' + rec.detail : '') + ' @ ' + rec.path).slice(0, 300),
                url: location.href.slice(0, 300)
              })
            }).catch(function () {});
          } catch (e) { /* репорт — best effort */ }
        }
        /* Конструктори самі ретраять 422 до 5 разів по 4с. Якщо повтор
           вдався — «збій» був транзитним, і негайний алерт збрехав би
           «покупець не зміг». Тому чекаємо 30с: успішний /cart/add за цей
           час скасовує репорт, а закриття сторінки шле його одразу —
           людина пішла посеред ретраїв = справжня втрата. */
        function report(status, detail, path) {
          if (sent + pending.length >= 3) return;
          var rec = { status: status, detail: detail, path: path };
          rec.t = setTimeout(function () { fire(rec); }, 30000);
          pending.push(rec);
        }
        function cancelPending() {
          while (pending.length) clearTimeout(pending.pop().t);
        }
        window.addEventListener('pagehide', function () {
          while (pending.length) {
            var rec = pending[0];
            clearTimeout(rec.t);
            fire(rec); /* keepalive: долетить і після закриття */
          }
        });
        function isCartAdd(url) {
          return /\/cart\/add(\.js)?($|\?)/.test(String(url || ''));
        }
        function shortPath(url) {
          return String(url || '').split('?')[0].slice(0, 80);
        }
        if (window.fetch) {
          var origFetch = window.fetch;
          window.fetch = function (input, init) {
            var url = (typeof input === 'string') ? input : ((input && input.url) || '');
            var method = (init && init.method) || (input && input.method) || 'GET';
            var p = origFetch.apply(this, arguments);
            if (/post/i.test(method) && isCartAdd(url)) {
              p.then(function (r) {
                if (!r) return;
                if (r.ok) { cancelPending(); return; }
                r.clone().json().catch(function () { return {}; }).then(function (b) {
                  var d = b && (b.description || b.message);
                  report(r.status, d ? String(d).slice(0, 180) : '', shortPath(url));
                });
              }).catch(function (e) {
                report('network', String((e && e.message) || e).slice(0, 120), shortPath(url));
              });
            }
            return p;
          };
        }
        if (window.XMLHttpRequest) {
          var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
          XMLHttpRequest.prototype.open = function (m, u) {
            this.__btCartAdd = /post/i.test(String(m)) && isCartAdd(u);
            this.__btCartUrl = String(u || '');
            return XO.apply(this, arguments);
          };
          XMLHttpRequest.prototype.send = function () {
            if (this.__btCartAdd) {
              this.addEventListener('loadend', function () {
                if (this.status >= 200 && this.status < 300) {
                  cancelPending();
                } else if (this.status === 0) {
                  report('network', '', shortPath(this.__btCartUrl));
                } else {
                  var d = '';
                  try {
                    var b = JSON.parse(this.responseText);
                    d = String(b.description || b.message || '').slice(0, 180);
                  } catch (e) { /* не-JSON тіло */ }
                  report(this.status, d, shortPath(this.__btCartUrl));
                }
              });
            }
            return XS.apply(this, arguments);
          };
        }
      })();
